import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { ApiService } from '@services/api.service';
import { Observable, of, from } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UkAccessGuard implements CanActivate {
    private alertShown = false;

    constructor(
        private apiService: ApiService,
        private alertController: AlertController
    ) { }

    async canActivate(): Promise<boolean> {
        try {
            await this.apiService.validateCountry();
            return true;
        } catch (error: any) {
            if (error?.status === 403) {
                await this.showBlockingAlert();
            }
            return false;
        }
    }

    private async showBlockingAlert(): Promise<void> {
        if (this.alertShown) return;

        this.alertShown = true;

        const alert = await this.alertController.create({
            header: 'Service Unavailable',
            message: 'This service is only available to UK residents.',
            backdropDismiss: false,
            keyboardClose: false,
            buttons: [] // no dismiss button
        });

        await alert.present();
    }
}